import tinycolor from 'tinycolor2';

import { Icon } from '~/modules/elements/akui/icon';
import styles from '~/modules/game-engine/drawing/styles';

export function PassTheMicProgress(props: { progress: number; color: string }) {
  return (
    <div
      className="absolute top-0 left-0 h-2 w-full origin-left"
      data-test="pass-the-mic-progress"
      style={{
        background: props.color,
        transform: `scaleX(${props.progress / 100})`,
      }}
    />
  );
}

export function PassTheMicSymbol({ active = false }: { active?: boolean }) {
  return (
    <Icon
      icon="ic:baseline-swap-horiz"
      className="ml-5 text-[1em]!"
      style={{
        color: active ? styles.colors.text.active : undefined,
      }}
    />
  );
}

export function PassTheMicHandover(props: { name: string; color: string; msToChange: number }) {
  return (
    <div
      className="stroke-text flex shrink-0 items-center gap-3.5 rounded-full bg-[rgba(255,165,0,0.16)] px-5 py-2 whitespace-nowrap shadow-[inset_0_0_0_2px_rgb(255,165,0)]"
      data-test="pass-the-mic-handover">
      <Icon icon="ic:baseline-swap-horiz" className="text-[1.625rem]!" style={{ color: styles.colors.text.active }} />
      <span className="text-lg font-black tracking-[.04em] uppercase">
        <span style={{ color: props.color }}>{props.name}</span> takes over
      </span>
      <span className="text-lg font-bold tabular-nums">{Math.ceil(props.msToChange / 1000)} s</span>
    </div>
  );
}

export function SingerTag({ name, color, upcoming = false }: { name: string; color: string; upcoming?: boolean }) {
  return (
    <span
      className="mr-3 inline-flex h-[1.875rem] items-center rounded-md px-2.5 align-middle text-[0.9375rem] leading-none font-black tracking-[.04em] text-black uppercase"
      style={{ background: upcoming ? tinycolor(color).setAlpha(0.55).toRgbString() : color }}>
      {name}
    </span>
  );
}

export function TradingLinesOrder({ singers }: { singers: { name: string; color: string }[] }) {
  return (
    <div
      className="stroke-text flex items-center justify-center gap-5 text-[1.625rem] font-bold text-white/55"
      data-test="trading-lines-order">
      <span className="inline-flex h-[2.125rem] items-center gap-2.5 rounded-full bg-white/10 px-3.5 text-[1.0625rem] tracking-[.06em] text-white/70 uppercase">
        Trading lines
      </span>
      <span>
        {singers.map((singer, index) => (
          <span key={`${singer.name}-${index}`}>
            {index > 0 && ' → '}
            <span style={{ color: singer.color }}>{singer.name}</span>
          </span>
        ))}
      </span>
    </div>
  );
}
